import * as React from 'react';
import Carousel from "../../../containers/Carousel";
import PlayerPoints from "../../../containers/PlayerPoints";
import StatsHeadToHead from "../../../containers/StatsHeadToHead";
import StatsOverall from "../../../containers/StatsOverall";
import StatsForm from "../../../containers/StatsForms";
import StatsRanking from "../../../containers/StatsRanking";
import useTranslation from '../../../hooks/useTranslation';

const StatisticsCarousel = () => {
    const statisticsOverallTitle = useTranslation('StatisticsOverall_title');
    const statisticsH2HTitle = useTranslation('StatisticsH2H_title');
    const statisticsH2HSubtitle = useTranslation('StatisticsH2H_subtitle');
    const statisticsFormTitle = useTranslation('StatisticsForm_title');
    const statisticsFormSubtitle = useTranslation('StatisticsForm_subtitle');
    const statisticsRankingTitle = useTranslation('StatisticsRanking_title');

    return (
        <div className="carouselWrapper">
            <Carousel>
                <StatsOverall       displayHeadline = {statisticsOverallTitle}
                                    verticalStretch = {true} />
                <StatsHeadToHead    displayHeadline = {statisticsH2HTitle}
                                    displaySubtitle = {statisticsH2HSubtitle} />
                <StatsForm          displayHeadline = {statisticsFormTitle} 
                                    displaySubtitle = {statisticsFormSubtitle} />
                <PlayerPoints       displayHeadline = {statisticsRankingTitle} >
                    <StatsRanking rankingOverlay = { true } />
                </PlayerPoints>
            </ Carousel>
        </div>
    );
}

export default StatisticsCarousel;
